import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { dataportfolio, meta } from "../../content_option";
import { homelabArticles } from "../../homelab/articles";

const Tags = ({ tags }) =>
  tags ? (
    <div className="po_item__tags">
      {tags.map((tag, j) => (
        <span className="po_item__tag" key={j}>
          {tag}
        </span>
      ))}
    </div>
  ) : null;

export const Portfolio = () => {
  return (
    <HelmetProvider>
      <Container className="About-header projects_wrap">
        <Helmet>
          <meta charSet="utf-8" />
          <title> Projects | {meta.title} </title>{" "}
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <p className="section_label"><span className="idx">$</span> ls ~/projects</p>
            <h1 className="display-4 mb-4"> Projects &amp; Homelab </h1>{" "}
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>

        {dataportfolio.length > 0 && (
        <div className="mb-5 po_items_ho">
          {dataportfolio.map((data, i) => (
            <div key={i} className="po_item">
              <span className="po_prefix">{"//"}</span>
              <h4 className="po_item__title">{data.title}</h4>
              <p className="po_item__desc">{data.description}</p>
              <Tags tags={data.tags} />
              <a
                className="po_item__link"
                href={data.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                view project →
              </a>
            </div>
          ))}
        </div>
        )}

        <p className="section_label"><span className="idx">$</span> ls ~/homelab/writeups</p>
        <hr className="t_border my-4 ml-0 text-left" />
        <div className="po_items_ho">
          {homelabArticles.map((a) => (
            <div key={a.slug} className="po_item">
              <span className="po_prefix">{"//"}</span>
              <h4 className="po_item__title">{a.title}</h4>
              <p className="po_item__desc">{a.summary}</p>
              <Tags tags={a.tags} />
              <Link className="po_item__link" to={`/homelab/${a.slug}`}>
                read the writeup →
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </HelmetProvider>
  );
};
